window.onload = function() {
  const voltageInput = document.getElementById('voltage');
  const currentInput = document.getElementById('current');
  const resistanceInput = document.getElementById('resistance');
  const powerInput = document.getElementById('power');
  const voltageUnit = document.getElementById('voltage-unit');
  const currentUnit = document.getElementById('current-unit');
  const resistanceUnit = document.getElementById('resistance-unit');
  const powerUnit = document.getElementById('power-unit');

  const voltageSVG = document.getElementById('voltage-value');
  const currentSVG = document.getElementById('current-value');
  const resistanceSVG = document.getElementById('resistance-value');
  const powerSVG = document.getElementById('power-value');

  const resultDiv = document.getElementById('result');

  const numDecimal = 4;

  // Keeps track of which field is currently being computed (auto-updated)
  let computedField = null;
  // Prevent infinite loops
  let suppress = false;

  // Unit factors for conversion to SI base units
  const voltageFactors = { 'V': 1, 'mV': 1e-3, 'kV': 1e3 };
  const currentFactors = { 'A': 1, 'mA': 1e-3, 'uA': 1e-6 };
  const resistanceFactors = { 'Ω': 1, 'kΩ': 1e3, 'MΩ': 1e6 };
  const powerFactors = { 'W': 1, 'mW': 1e-3, 'kW': 1e3 };

  function parseOrNaN(x) {
    return (x === "" || x === null) ? NaN : parseFloat(x);
  }

  function showResult(label, value, unit) {
    info.innerHTML = `<b>${label}:</b> <span style="color: green">${value.toFixed(numDecimal)} ${unit} </span>`;
  }

  function toSI(value, field) {
    if (isNaN(value)) return NaN;
    if (field === 'voltage') return value * voltageFactors[voltageUnit.value];
    if (field === 'current') return value * currentFactors[currentUnit.value];
    if (field === 'resistance') return value * resistanceFactors[resistanceUnit.value];
    if (field === 'power') return value * powerFactors[powerUnit.value];
    return value;
  }

  function fromSI(value, field) {
    if (isNaN(value)) return "";
    if (field === 'voltage') return value / voltageFactors[voltageUnit.value];
    if (field === 'current') return value / currentFactors[currentUnit.value];
    if (field === 'resistance') return value / resistanceFactors[resistanceUnit.value];
    if (field === 'power') return value / powerFactors[powerUnit.value];
    return value;
  }

  function getUnit(field) {
    if (field === 'voltage') return voltageUnit.value;
    if (field === 'current') return currentUnit.value;
    if (field === 'resistance') return resistanceUnit.value;
    if (field === 'power') return powerUnit.value;
    return '';
  }

  function highlightComputedField() {
    // Remove highlight from all
    voltageInput.classList.remove('computed-field');
    currentInput.classList.remove('computed-field');
    resistanceInput.classList.remove('computed-field');
    // Only highlight the computed field
    if (computedField === 'voltage') voltageInput.classList.add('computed-field');
    if (computedField === 'current') currentInput.classList.add('computed-field');
    if (computedField === 'resistance') resistanceInput.classList.add('computed-field');
  }

  function updatePower(v, i, r) {
    let p = NaN;
    if (!isNaN(v) && !isNaN(i)) {
      p = v * i;
    } else if (!isNaN(i) && !isNaN(r)) {
      p = i*i*r;
    } else if (!isNaN(v) && !isNaN(r)) {
      p = (v*v)/r;
    }
    if (!isNaN(p)) {
      powerInput.value = fromSI(p, 'power').toFixed(numDecimal);
    } else {
      powerInput.value = "";
    }
  }

  function updateSVG() {
    voltageSVG.textContent = (voltageInput.value != "") ? voltageInput.value + ' ' + voltageUnit.value : "";
    resistanceSVG.textContent = (resistanceInput.value != "") ? resistanceInput.value + ' ' + resistanceUnit.value : "";
    currentSVG.textContent = (currentInput.value != "")? currentInput.value + ' ' + currentUnit.value : "";
    powerSVG.textContent = (powerInput.value != "") ? powerInput.value + ' ' + powerUnit.value : "";
  }

  function computeAndUpdate() {
    if (suppress) return;

    // Read values and convert to SI units
    let v = toSI(parseOrNaN(voltageInput.value), 'voltage');
    let i = toSI(parseOrNaN(currentInput.value), 'current');
    let r = toSI(parseOrNaN(resistanceInput.value), 'resistance');

    updateSVG();

    // Count filled
    let filled = [!isNaN(v), !isNaN(i), !isNaN(r)].filter(Boolean).length;
    if (filled < 2) {
      info.innerHTML = "";
      computedField = null;
      highlightComputedField();
      powerInput.value = "";
      return;
    }

    suppress = true;
    try {
      if (computedField === null) {
        // First time: pick the empty field as computedField
        if (isNaN(v)) computedField = 'voltage';
        else if (isNaN(i)) computedField = 'current';
        else if (isNaN(r)) computedField = 'resistance';
      }

      highlightComputedField();

      // Only update the computedField!
      if (computedField === 'voltage' && !isNaN(i) && !isNaN(r)) {
        v = i * r;
        voltageInput.value = fromSI(v, 'voltage').toFixed(numDecimal);
        showResult('Calculated Voltage', fromSI(v, 'voltage'), getUnit('voltage'));
      } else if (computedField === 'current' && !isNaN(v) && !isNaN(r)) {
        i = v / r;
        currentInput.value = fromSI(i, 'current').toFixed(numDecimal);
        showResult('Calcuated Current', fromSI(i, 'current'), getUnit('current'));
      } else if (computedField === 'resistance' && !isNaN(v) && !isNaN(i)) {
        r = v / i;
        resistanceInput.value = fromSI(r, 'resistance').toFixed(numDecimal);
        showResult('Calculated Resistance', fromSI(r, 'resistance'), getUnit('resistance'));
      }
      // Always update power if possible
      updatePower(v, i, r);
    } catch (e) {
      info.innerHTML = `<span id="error">${e.message}</span>`;
      powerInput.value = "";
    }
    updateSVG();
    suppress = false;
  }

  function onEdit(field) {
    return function(e) {
      if (suppress) return;
      // If user edits the computed field, treat that field as user-controlled, and pick a new computed field
      if (computedField === field) {
        // Choose a new computedField: pick the empty one, or if all filled, pick any except the one just edited
        let v = toSI(parseOrNaN(voltageInput.value), 'voltage');
        let i = toSI(parseOrNaN(currentInput.value), 'current');
        let r = toSI(parseOrNaN(resistanceInput.value), 'resistance');
        if (field !== 'voltage' && isNaN(v)) computedField = 'voltage';
        else if (field !== 'current' && isNaN(i)) computedField = 'current';
        else if (field !== 'resistance' && isNaN(r)) computedField = 'resistance';
        else {
          // All filled: pick a different field
          computedField = (field === 'voltage') ? 'current' : 'voltage';
          if (field !== 'resistance' && computedField === field) computedField = 'resistance';
        }
      }
      computeAndUpdate();
    };
  }

  voltageInput.addEventListener('input', onEdit('voltage'));
  currentInput.addEventListener('input', onEdit('current'));
  resistanceInput.addEventListener('input', onEdit('resistance'));

  voltageUnit.addEventListener('change', computeAndUpdate);
  currentUnit.addEventListener('change', computeAndUpdate);
  resistanceUnit.addEventListener('change', computeAndUpdate);
  powerUnit.addEventListener('change', function() {
    // Just recalculate and reformat power output
    let v = toSI(parseOrNaN(voltageInput.value), 'voltage');
    let i = toSI(parseOrNaN(currentInput.value), 'current');
    let r = toSI(parseOrNaN(resistanceInput.value), 'resistance');
    updatePower(v, i, r);
    updateSVG();

  });
};